var _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawerSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_678",
    "data-name": "Group 678",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M3,1H21a2.006,2.006,0,0,1,2,2V15a2.006,2.006,0,0,1-2,2H3a2.006,2.006,0,0,1-2-2V3A2.006,2.006,0,0,1,3,1Z",
    fill: "none",
    stroke: "#b6b6c7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_274",
    "data-name": "Line 274",
    x2: 22,
    transform: "translate(1 7)",
    fill: "none",
    stroke: "#b6b6c7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerSubscription);
export default __webpack_public_path__ + "static/media/drawer-subscription.f2edde2332a6d5965b6465da4864974a.svg";
export { ForwardRef as ReactComponent };